import { request } from '@/utils/request';
import type { ApiResponse, WrappedResult, WrappedItemsResult } from './types';

const farmersApi = {
  getAll(params?: cyrian.api.farmers.GetParams): ApiResponse<WrappedItemsResult<cyrian.api.farmers.Farmer[]>> {
    return request({
      method: 'get',
      url: '/farmers',
      params,
    });
  },
  getOne(id: number): ApiResponse<WrappedResult<cyrian.api.farmers.Farmer>> {
    return request({
      method: 'get',
      url: `/farmers/${id}`,
    });
  },
  create(data: cyrian.api.farmers.FarmerParams): ApiResponse<WrappedResult<cyrian.api.farmers.Farmer>> {
    return request({
      method: 'post',
      url: '/farmers',
      data,
    });
  },
  update(id: number, data: cyrian.api.farmers.FarmerParams): ApiResponse<WrappedResult<cyrian.api.farmers.Farmer>> {
    return request({
      method: 'patch',
      url: `/farmers/${id}`,
      data,
    });
  },
  delete(id: number): ApiResponse<WrappedResult<any>> {
    return request({
      method: 'delete',
      url: `/farmers/${id}`,
    });
  },
  createFromExcelByType(
    data: cyrian.api.farmers.CreateFarmersFromExcelByTypeFormData,
  ): ApiResponse<WrappedResult<any>> {
    const formData = new FormData();
    formData.append('file', data.file as File);
    formData.append('sourceDocumentType', data.sourceDocumentType);
    if (data.cooperativeId) {
      formData.append('cooperativeId', String(data.cooperativeId));
    }

    return request({
      method: 'post',
      url: '/farmers/create-from-excel-by-type',
      timeout: 90000,
      data: formData,
    });
  },
  getPlots(
    farmerId: number,
    params: cyrian.api.farmPlots.GetParams,
  ): ApiResponse<WrappedResult<cyrian.api.farmPlots.FarmPlot[]>> {
    return request({
      method: 'get',
      url: `/farmers/${farmerId}/plots`,
      params,
    });
  },
};

export default farmersApi;
